module.exports = __webpack_public_path__ + "img/phone-aruba-health-app.6d484ba9.png";